export default __webpack_public_path__ + "static/LTZ-DESKTOP-b2d21c4d597a3836334401cd91b968a0.jpg";